  const TD = (window.AS && window.AS.testDatos) || null;
  const TQ_BASE = {"count_q": "Pregunta {n} de {total}", "volver": "← Volver", "resultado": "Tu resultado", "eyebrow": "Tu rutina", "frase_exacta": "Según lo que nos contaste, esta es la rutina que mejor calza con lo que buscas: <b>{meta}</b>.", "frase_pronto": "Pronto sumaremos una rutina específica para <b>{meta}</b>. Mientras tanto, esta es la que mejor calza contigo.", "frase_cat": "Según lo que nos contaste, esto es lo que mejor calza con lo que buscas: <b>{meta}</b>.", "regalo": "<b>Un regalo que se usa todos los días.</b> Llega a su casa y se paga al recibir.", "ver_rutina": "Ver mi rutina", "ver_todo": "Ver todo {categoria}", "otra_vez": "Volver a empezar", "aviso": "Esta recomendación no reemplaza la indicación de un profesional de la salud.", "agregar": "Agregar", "oferta_2x1": "2x1 · lleva 2, paga 1", "ahorras": "Ahorras"};
  const tq = (k, vars) => { let t = (TD && TD.textos && TD.textos[k] && String(TD.textos[k]).trim()) ? TD.textos[k] : TQ_BASE[k]; Object.entries(vars || {}).forEach(([a, b]) => { t = t.split('{' + a + '}').join(b); }); return t; };
  const GOALS = {
    energia: 'tener más energía en el día', descanso: 'descansar mejor en la noche', mover: 'moverte con más soltura',
    liviano: 'sentirte más liviano', metab: 'cuidar tu metabolismo', edad: 'envejecer mejor',
  };
  const Q = [
    { key: 'who', title: '¿Para quién es?', opts: [
      ['hombre', 'user', 'Para mí', 'Soy hombre'], ['mujer', 'user', 'Para mí', 'Soy mujer'],
      ['regalo-el', 'gift', 'Es un regalo para él', ''], ['regalo-ella', 'gift', 'Es un regalo para ella', ''] ] },
    { key: 'goal', title: '¿Qué te gustaría mejorar primero?', opts: [
      ['energia', 'bolt', 'Tener más energía en el día', ''], ['descanso', 'moon', 'Descansar mejor en la noche', ''],
      ['mover', 'move', 'Moverme con más soltura', ''], ['liviano', 'leaf', 'Sentirme más liviano/a', ''],
      ['metab', 'flame', 'Cuidar mi metabolismo', ''], ['edad', 'hourglass', 'Envejecer mejor', ''] ] },
    { key: 'pack', title: '¿Cómo quieres empezar?', opts: [
      ['basico', 'leaf', 'Simple', '2 productos · versión Básico'], ['completo', 'sparkle', 'Completo', '3 productos por solo $5.000 más'] ] },
  ];
  /* [Shopify] preguntas y opciones salen de los bloques de la sección (si existen) */
  if (TD && TD.preguntas && TD.preguntas.length) {
    Q.length = 0;
    TD.preguntas.forEach((p) => Q.push({ key: p.key, title: p.title,
      opts: TD.opciones.filter((o) => o.q === p.key).map((o) => [o.v, o.ic || 'check', o.t, o.s || '']) }));
    TD.opciones.forEach((o) => { if (o.meta) GOALS[o.v] = o.meta; });
  }
  const answers = {};
  const stage = document.getElementById('quiz-stage');
  const bar = document.querySelector('.quiz-progress i');

  function intro() {
    if (document.querySelector('[data-quiz-intro]')) { bar.style.width = '4%'; document.getElementById('quiz-start').addEventListener('click', () => ask(0)); return; }
    bar.style.width = '4%';
    stage.innerHTML = `<div class="quiz-step" style="justify-items:start">
      <span class="eyebrow">Test gratis · 20 segundos</span>
      <h1 style="font-size:clamp(2.3rem,8vw,3.8rem)">¿No sabes por dónde empezar?</h1>
      <p class="lead">Responde 3 preguntas y te recomendamos la rutina que calza contigo.</p>
      <button class="btn btn-cta" type="button" id="quiz-start">Empezar ${ic('arrow')}</button>
      <p style="font-size:.84rem;color:var(--muted)">Sin preguntas sobre enfermedades: recomendamos por metas del día a día.</p>
    </div>`;
    document.getElementById('quiz-start').addEventListener('click', () => ask(0));
  }

  function ask(i) {
    const q = Q[i];
    bar.style.width = `${((i + 1) / (Q.length + 1)) * 100}%`;
    stage.innerHTML = `<div class="quiz-step">
      <span class="quiz-count">${tq('count_q', { n: i + 1, total: Q.length })}</span>
      <h2>${q.title}</h2>
      <div class="options">${q.opts.map(([v, icn, t, s]) => `<button class="option" type="button" data-v="${v}"><span class="o-ic">${ic(icn)}</span><span>${t}${s ? `<small>${s}</small>` : ''}</span></button>`).join('')}</div>
      ${i > 0 ? `<button class="back-btn" type="button" id="quiz-back">${tq('volver')}</button>` : ''}
    </div>`;
    stage.querySelectorAll('.option').forEach((b) => b.addEventListener('click', () => {
      answers[q.key] = b.dataset.v;
      i + 1 < Q.length ? ask(i + 1) : result();
    }));
    const back = document.getElementById('quiz-back');
    if (back) back.addEventListener('click', () => ask(i - 1));
    stage.querySelector('h2').focus?.();
  }

  /* Fila compacta para el resultado: la tarjeta del catálogo no cabe en esta
     columna en el celular (Jacsson, 2026-10-05). Foto y botón salen de productCard
     para que el carrito siga funcionando igual. */
  function recItem(x) {
    const d = document.createElement('div'); d.innerHTML = productCard(x);
    const foto = d.querySelector('.p-media a')?.innerHTML || '';
    const oferta = PACKS[x.id] && es2x1(x) ? `<span class="rec-2x1">${tq('oferta_2x1')}</span>` : '';
    return `<article class="p-card rec" id="p${x.id}">
      <a class="rec-img" href="producto.html?id=${x.id}" aria-label="Ver ${x.name}">${foto}</a>
      <div class="rec-info">
        <a class="rec-name" href="producto.html?id=${x.id}">${x.name}</a>
        <span class="rec-desc">${x.desc}</span>
        ${oferta}
        <span class="price" data-precio>${clp(x.price)}</span>
      </div>
      <button class="btn btn-cta p-add rec-add" type="button" data-cart aria-label="Agregar ${x.name} al carrito">${ic('cart')}<span>${tq('agregar')}</span></button>
    </article>`;
  }

  function result() {
    bar.style.width = '100%';
    const forHim = answers.who === 'hombre' || answers.who === 'regalo-el';
    const gift = answers.who.startsWith('regalo');
    const key = forHim ? 'energia' : 'mujer';
    const k = KITS[key], p = KIT_PACKS[answers.pack];
    const items = k.products.slice(0, p.count);
    const exact = answers.goal === 'energia';
    /* Cada meta recomienda productos de SU categoría (Jacsson, 2026-10-05: antes
       todo terminaba en uno de los 2 kits y el test parecía no escuchar). Solo
       "energía" sigue llevando al kit, que es la rutina armada para eso. */
    const CAT_META = { descanso: 'descanso', mover: 'articulaciones', liviano: 'digestion', metab: 'metabolismo', edad: 'longevidad' };
    if (!exact && CAT_META[answers.goal]) {
      const sexo = forHim ? 'H' : 'M';
      const pool = PRODUCTS.filter((x) => x.cat === CAT_META[answers.goal] && (x.sex === 'A' || x.sex === sexo) && !APARTADOS.includes(x.id));
      const mezcla = pool.map((x) => [x.top ? -1 : Math.random(), x]).sort((a, b) => a[0] - b[0]).map((x) => x[1]);
      const recs = mezcla.slice(0, p.count);
      const cat = CATS.find((c) => c.id === CAT_META[answers.goal]);
      stage.innerHTML = `<div class="quiz-step">
      <span class="quiz-count">${tq('resultado')}</span>
      <div class="result">
        <span class="eyebrow" style="justify-self:start">${tq('eyebrow')}</span>
        <h2>${cat.name}</h2>
        <p>${tq('frase_cat', { meta: GOALS[answers.goal] })}</p>
        ${gift ? `<p>${tq('regalo')}</p>` : ''}
        <div class="rec-list">${recs.map(recItem).join('')}</div>
        <a class="btn btn-cta btn-block" href="productos.html#${cat.id}">${tq('ver_todo', { categoria: cat.name })} ${ic('arrow')}</a>
        <button class="back-btn" type="button" id="quiz-again" style="justify-self:center">${tq('otra_vez')}</button>
      </div></div>`;
      if (window.ASTienda) ASTienda.links(stage);
    document.getElementById('quiz-again').addEventListener('click', () => { Object.keys(answers).forEach((a) => delete answers[a]); ask(0); });
      return;
    }
    const bg = key === 'energia' ? '#0E0E0E' : '#F6E3EC';
    stage.innerHTML = `<div class="quiz-step">
      <span class="quiz-count">${tq('resultado')}</span>
      <div class="result">
        <span class="eyebrow" style="justify-self:start">${tq('eyebrow')}</span>
        <h2>${k.name} <span style="color:var(--brand)">${p.name}</span></h2>
        <div class="result-media" style="background:${bg}">${items.map((x) => shot(x.img, x.name)).join('')}</div>
        <p>${exact
          ? tq('frase_exacta', { meta: GOALS[answers.goal] })
          : tq('frase_pronto', { meta: GOALS[answers.goal] })}</p>
        ${gift ? `<p>${tq('regalo')}</p>` : ''}
        <ul class="checklist">${items.map((x) => `<li><span class="ck">${ic('check')}</span>${x.name}</li>`).join('')}</ul>
        <div class="price-row"><span class="price">${clp(p.price)}</span><span class="strike">${clp(p.strike)}</span><span class="save">${tq('ahorras')} ${clp(p.strike - p.price)}</span></div>
        <a class="btn btn-cta btn-block" href="kit-${key}.html#ofertas">${tq('ver_rutina')} ${ic('arrow')}</a>
        <button class="back-btn" type="button" id="quiz-again" style="justify-self:center">${tq('otra_vez')}</button>
        <small>${tq('aviso')}</small>
      </div>
    </div>`;
    if (window.ASTienda) ASTienda.links(stage);
    document.getElementById('quiz-again').addEventListener('click', () => { Object.keys(answers).forEach((a) => delete answers[a]); ask(0); });
  }

